window.documentReady = (fn) => {
	if (document.attachEvent ? 'complete' === document.readyState : document.readyState !== 'loading') {
		fn()
	} else {
		document.addEventListener('DOMContentLoaded', fn)
	}
}

// https://codepen.io/PiotrBerebecki/pen/yaWQwZ
window.scrollToElement = (element, to, duration = 800) => {
	if (duration <= 0) { return }

	const difference = to - element.scrollTop
	const perTick = difference / duration * 10

	setTimeout(() => {
		element.scrollTop = element.scrollTop + perTick
		if (element.scrollTop === to) { return }
		window.scrollToElement(element, to, duration - 10)
	}, 10)
}

// Classes
window.hasClass = (el, className) => {
	if (el.classList)
	{return el.classList.contains(className)}
	return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className)
}

window.addClass = (el, className) => {
	if (el.classList)
	{el.classList.add(className)}
	else
	{el.className += ' ' + className}
}

window.removeClass = (el, className) => {
	if (el.classList) {
		el.classList.remove(className)
	}	else {
		el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ')
	}
}
